import { css } from 'styled-components';

export const DueDatePickerPopoverStyles = css`
  .due__date__picker {
    padding: 0;

    .ant-popover-arrow,
    .ant-picker-range-arrow {
      display: none;
    }

    .ant-popover-inner-content {
      border-bottom: solid 1px var(--border-color);
      padding: 0 var(--spacing-04);
      width: 100%;
    }

    .ant-picker {
      width: 100%;

      &:not(.ant-picker-range).ant-picker-focused {
        border-radius: 0;
        border-bottom: solid 2px var(--primary-color) !important;
      }
    }

    .ant-picker-panel-container {
      border-radius: 0;
      box-shadow: none;
      transition: none;

      .ant-picker-panel {
        border: none;
      }
    }

    .ant-picker-body {
      padding: var(--spacing-04) var(--spacing-03);
    }

    .ant-picker-year-panel,
    .ant-picker-month-panel,
    .ant-picker-date-panel {
      width: 272px;

      .ant-picker-content {
        height: 212px;
      }
    }

    .ant-picker-range-wrapper {
      .ant-picker-year-panel,
      .ant-picker-month-panel {
        width: 334px;
      }

      .ant-picker-date-panel .ant-picker-content {
        width: 100%;
      }
    }

    .ant-picker-suffix {
      display: none;
    }

    .ant-picker-input > input {
      margin-left: 0;
    }

    .ant-popover-inner-content + div,
    .ant-picker-dropdown {
      position: static !important;
    }

    .ant-picker-dropdown-range {
      padding: 0;
    }

    .ant-picker-footer-extra {
      line-height: var(--heading-6-line-height);
      padding: 0;
    }

    .ant-picker-footer {
      border-top: solid 1px var(--border-color);
      border-bottom: none;
    }
  }
`;
